/**
 * History auto-text like `fotky: 2 nových` / `fotka: 1 nová` — counts only.
 * Diary PDF/UI already embeds structured `photos[]`; these lines pollute Poznámky.
 */

const PHOTO_COUNT_NOISE =
  /^fotk[ay]:\s*\d+(\s+nov(á|ých|é|ý|ých))?\s*\.?$/i;

/** True when the whole line is only a photo-count summary. */
export function isDiaryPhotoCountNoiseLine(line: string | null | undefined): boolean {
  const t = String(line ?? '').trim();
  if (!t) return false;
  return PHOTO_COUNT_NOISE.test(t);
}

/**
 * Drop photo-count noise from a free-text note (split by newlines / `;`).
 * Returns null when nothing useful remains.
 */
export function scrubDiaryNotePhotoCountNoise(
  note: string | null | undefined,
): string | null {
  const raw = String(note ?? '').trim();
  if (!raw) return null;
  if (isDiaryPhotoCountNoiseLine(raw)) return null;

  const parts = raw
    .split(/\n|;|\s+·\s+/)
    .map((p) => p.trim())
    .filter((p) => p.length > 0 && !isDiaryPhotoCountNoiseLine(p));

  if (!parts.length) return null;
  // Preserve original multi-line / list shape when possible.
  if (raw.includes('\n')) return parts.join('\n');
  if (raw.includes(';')) return parts.join('; ');
  if (/\s+·\s+/.test(raw)) return parts.join(' · ');
  return parts.join(' ');
}

/** Filter noise lines from already-split note parts (display pipelines). */
export function filterDiaryNoteParts(parts: string[]): string[] {
  return parts.filter((p) => !isDiaryPhotoCountNoiseLine(p));
}
